import { useEffect, useState } from "react";
import {
  TimerControllerHeaderTabs,
  TimerControllerBackgroundBox,
} from "../../style";
import {
  ControllerSkinSelectorImageUpload,
  ControllerSkinSelectorLeftWrapper,
  ControllerSkinSelectorRightWrapper,
  ControllerSkinSelectorUploadWrapper,
  ControllerSkinSelectorImageWrapper,
  ControllerSkinSelectorWrapper,
  ControllerSkinSelectorImageBorder,
  ControllerSkinSelectorLogoInfo,
  ControllerSkinSelectorBackgroundInfo,
  ControllerSkinSelectorButtonWrapper,
  ControllerSkinSelectorViewWrapper,
  ControllerSkinSelectorHeader,
  ControllerSkinSelectorSubPrizeFontWrapper,
} from "./style";
import { useTimerImage } from "./hooks/use-timer-image";
import { useParams } from "react-router-dom";
import { isTournamentAccess } from "../../../../utils/owner";
import { pubState } from "../../../../recoil/pub.atom";
import { useRecoilValue } from "recoil";

const TimerControllerSkinSelector = () => {
  const {
    coverImageUrl,
    backgroundImageUrl,
    handleClick,
    handleDrop,
    handleDeleteCover,
    handleDeleteBackground,
  } = useTimerImage();
  const { id } = useParams();
  const tournamentId = id?.replace(/[^0-9]/g, "");
  const [tab, setTab] = useState("horizontal");
  const [selectedSkin, setSelectedSkin] = useState<number>(1);
  const [subPrizeFont, setSubPrizeFont] = useState(20);
  const pub = useRecoilValue(pubState);

  useEffect(() => {
    const font = localStorage.getItem("subPrizeFont");
    if (font) {
      setSubPrizeFont(+font);
    }
  }, []);

  const changeSubPrizeFont = (value: number) => {
    if (
      tournamentId &&
      !isTournamentAccess(+tournamentId, pub?.tournamentIds)
    ) {
      alert(`토너먼트 ID ${tournamentId}에 대한 권한이 없습니다. `);
      return;
    }
    const result = subPrizeFont + value;
    setSubPrizeFont(result);
    localStorage.setItem("subPrizeFont", result.toString());
  };

  const skins = Array.from({ length: 5 }, (_, i) => ({
    id: i + 1,
    thumbnail: `/image-web/timer/timer${i + 1}${
      tab === "horizontal" ? "" : "_vertical"
    }.png`,
  }));

  const skinTabs = [
    { name: "가로형", value: "horizontal" },
    { name: "세로형", value: "vertical" },
  ];

  return (
    <ControllerSkinSelectorWrapper>
      <ControllerSkinSelectorLeftWrapper width="1087px" height="620px">
        <ControllerSkinSelectorHeader>
          <TimerControllerHeaderTabs>
            {skinTabs.map((item, index) => (
              <div
                key={index}
                className={`button ${tab === item.value ? "select" : ""}`}
                onClick={() => setTab(item.value)}
              >
                {item.name}
              </div>
            ))}
          </TimerControllerHeaderTabs>
          <ControllerSkinSelectorSubPrizeFontWrapper>
            <div>부상 폰트 크기 조절</div>
            {subPrizeFont > 0 && (
              <img
                src="/image-web/tournament/minus.svg"
                onClick={() => {
                  changeSubPrizeFont(-1);
                }}
                alt="minus"
              />
            )}
            {subPrizeFont} PX
            <img
              src="/image-web/tournament/plus.svg"
              onClick={() => {
                changeSubPrizeFont(+1);
              }}
              alt="plus"
            />
          </ControllerSkinSelectorSubPrizeFontWrapper>
        </ControllerSkinSelectorHeader>
        <ControllerSkinSelectorImageWrapper isHorizontal={tab === "horizontal"}>
          <img src={skins[selectedSkin - 1].thumbnail} alt="select_skin" />
          <ControllerSkinSelectorViewWrapper
            isHorizontal={tab === "horizontal"}
          >
            {skins.map((skin, index) =>
              skin.id === selectedSkin && tab === "horizontal" ? (
                ""
              ) : (
                <div className="view" onClick={() => setSelectedSkin(skin.id)}>
                  <img
                    key={index}
                    src={skin.thumbnail}
                    alt={`skin_${skin.id}`}
                  />
                </div>
              ),
            )}
          </ControllerSkinSelectorViewWrapper>
        </ControllerSkinSelectorImageWrapper>
        <ControllerSkinSelectorButtonWrapper
          onClick={() => {
            if (!tournamentId) return;
            const isVertical = tab !== "horizontal";
            window.open(
              `/${isVertical ? "vertical/" : ""}timer${selectedSkin}/${tournamentId}`,
              "_blank",
            );
          }}
        >
          타이머 선택
        </ControllerSkinSelectorButtonWrapper>
      </ControllerSkinSelectorLeftWrapper>

      <ControllerSkinSelectorRightWrapper>
        <TimerControllerBackgroundBox>
          <div className="title">
            매장 로고 업로드
            <img
              src="/image-web/controller/delete-image.svg"
              alt="delete"
              onClick={handleDeleteCover}
            />
          </div>
          <ControllerSkinSelectorUploadWrapper>
            <ControllerSkinSelectorImageBorder>
              <ControllerSkinSelectorImageUpload
                onClick={() => handleClick()}
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => e.preventDefault()}
              >
                {coverImageUrl ? (
                  <img src={coverImageUrl} alt="logo" />
                ) : (
                  <div className="circle" />
                )}
              </ControllerSkinSelectorImageUpload>
            </ControllerSkinSelectorImageBorder>
            <ControllerSkinSelectorLogoInfo>
              <div className="title">로고를 올려주세요! </div>
              <div className="info">
                10MB 이하, 50×50px 이상
                <br /> 260×260px 이하의
                <br />
                파일을 올려주세요
              </div>
            </ControllerSkinSelectorLogoInfo>
          </ControllerSkinSelectorUploadWrapper>
        </TimerControllerBackgroundBox>
        <TimerControllerBackgroundBox>
          <div className="title">
            블라인트 타이머 배경 이미지
            <img
              src="/image-web/controller/delete-image.svg"
              alt="delete"
              onClick={handleDeleteBackground}
            />
          </div>
          <ControllerSkinSelectorUploadWrapper>
            <ControllerSkinSelectorImageBorder width="428px" height="198px">
              <ControllerSkinSelectorImageUpload
                onClick={() => handleClick(false)}
                onDrop={(e) => handleDrop(e, false)}
                onDragOver={(e) => e.preventDefault()}
              >
                {backgroundImageUrl ? (
                  <img src={backgroundImageUrl} alt="back" />
                ) : (
                  <ControllerSkinSelectorBackgroundInfo>
                    <img src="/image-web/controller/image.svg" alt="back" />
                    <div className="title">
                      블라인드 타이머 배경 이미지를 올려주세요!
                    </div>
                    <div className="info">
                      10MB 이하, 400×400px 이상 1600×1600px 이하의
                      <br />
                      파일을 올려주세요
                    </div>
                  </ControllerSkinSelectorBackgroundInfo>
                )}
              </ControllerSkinSelectorImageUpload>
            </ControllerSkinSelectorImageBorder>
          </ControllerSkinSelectorUploadWrapper>
        </TimerControllerBackgroundBox>
      </ControllerSkinSelectorRightWrapper>
    </ControllerSkinSelectorWrapper>
  );
};

export default TimerControllerSkinSelector;
